import Featured     from './Featured'
import VueI18n      from 'vue-i18n'
import {i18n}       from './plugins/i18n.js'
import VueTour      from 'vue-tour'
import VTooltip     from 'v-tooltip'
import VueCookie    from 'vue-cookie'

require('vue-tour/dist/vue-tour.css')
const { sqrt } = require('mathjs')

window.Vue = require('vue');
window.Vue.use(VueTour)
window.Vue.use(VueI18n)
window.Vue.use(VTooltip)
window.Vue.use(VueCookie)

let app = new Vue({
    components: {
        'featured' :Featured,
    },
    el: '#vue_container',
    data: i18n,
})
jQuery(document).on('click', '.imageset_select',function () {
    var id = jQuery(this).attr('data-id');
    app.$children[0].getPost(id);
  })


jQuery(document).ready(function () {
      jQuery('.imageset_select').attr('tabIndex', '0');


      jQuery('.featured_content_sidebar_posts').on('focus', function(){
              jQuery('.imageset_select').attr('tabIndex', '0');
              jQuery('.imageset_select').on('keypress', function(e) {
                if(e.keyCode === 13){
                  var id = jQuery(this).attr('data-id');
                  app.$children[0].getPost(id);
                }
              })
      })
})


// var meshgrid = require('ndarray-meshgrid');
// var ndarray = require("ndarray")
//
// //linspace function
// function makeArr(startValue, stopValue, cardinality) {
//     var arr = [];
//     var step = (stopValue - startValue) / (cardinality - 1);
//     for (var i = 0; i < cardinality; i++) {
//       arr.push(startValue + (step * i));
//     }
//     return arr;
//   }
// var m = makeArr(-100,100,256);
// var z = meshgrid(m,m);
// var arr = meshgrid([-100, 100, 256], [-100, 100, 256]);
// var arr = meshgrid([-1, 1, 0.2], [0, 10, 1]);
//
//
// console.log(arr);
// function generate_image_array_data() {
//     var mm = makeArr((- 100), 100, 256);
//
//     let x = ndarray(new Float64Array(mm), mm).data;
//     x = [].slice.call(x);
//     let y = x;
//
//     var yy = sumArrays(squarearr(y), squarearr(x));
//     var zz = expArr((divideArr(Math.pow(30.0, 2),(multiplyArr((- 0.5), (sumArrays(squarearr(x),squarearr(y))))))))
//     let i = difArrays(multiplyArr(0.25, (expArr((divideArr(Math.pow(30.0, 2),(multiplyArr((- 0.5), (sumArrays(squarearr(x),squarearr(y)))))))),
//     multiplyArr(0.8, expArr((divideArr(Math.pow(10.0, 2),(multiplyArr((- 0.5), (sumArrays(squarearr(x),squarearr(y))))))))))));
//     let q = ((i * Math.cos(2.0 * 30.0)));
//     let u = ((i * Math.sin(((2.0 * Math.atan2(y, x)) + (0.15 * Math.PI)))) * (Math.sqrt((Math.pow(x, 2) + Math.pow(y, 2))) / 30.0));
//     let v = (0 * i);
//     return [x, y, i, q, u, v];
// }
//
// function squarearr(arr) {
//
//     let ret = [];
//
//     for (var i = 0, len = arr.length; i < len; i++) {
//         ret.push(arr[i] * arr[i]);
//     }
//
//     return ret;
// }
// function sumArrays(...arrays) {
//     const n = arrays.reduce((max, xs) => Math.max(max, xs.length), 0);
//     const result = Array.from({ length: n });
//     return result.map((_, i) => arrays.map(xs => xs[i] || 0).reduce((sum, x) => sum + x, 0));
//   }
// function difArrays(...arrays) {
//     const n = arrays.reduce((max, xs) => Math.max(max, xs.length), 0);
//     const result = Array.from({ length: n });
//     return result.map((_, i) => arrays.map(xs => xs[i] || 0).reduce((sum, x) => sum - x, 0));
//   }
// function multiplyArr(num,arr) {
//
//      let ret = [];
//
//      for (var i = 0, len = arr.length; i < len; i++) {
//          ret.push(arr[i] * num);
//      }
//
//      return ret;
//  }
//  function divideArr(num,arr) {
//
//     let ret = [];
//
//     for (var i = 0, len = arr.length; i < len; i++) {
//         ret.push(arr[i] / num);
//     }
//
//     return ret;
// }
// function expArr(arr) {
//
//    let ret = [];
//
//    for (var i = 0, len = arr.length; i < len; i++) {
//        ret.push(Math.exp(arr[i]));
//    }
//
//    return ret;
// }
